"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.statusTypes = exports.positions = void 0;
var positions = exports.positions = ['center', 'topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomRight', 'bottomCenter'];
var statusTypes = exports.statusTypes = ['success', 'warning', 'info', 'fail', 'loading'];